import OverviewCard from "./OverviewCard";
import { FiEye, FiDollarSign, FiShoppingCart, FiTrendingDown } from "react-icons/fi";

const stats = (dashboard) => [
    { title: "Page Views", value: dashboard.website_stats.page_views, icon: <FiEye size={16} />, accent: "sky" },
    { title: "Pricing Views", value: dashboard.website_stats.pricing_views, icon: <FiDollarSign size={16} />, accent: "amber" },
    { title: "Checkout", value: dashboard.checkout_started, icon: <FiShoppingCart size={16} />, accent: "violet" },
    { title: "Drop Off", value: dashboard.website_stats.drop_off, icon: <FiTrendingDown size={16} />, accent: "rose" },
];

const styles = {
    sky: "bg-sky-50 text-sky-600 ring-sky-100",
    amber: "bg-amber-50 text-amber-600 ring-amber-100",
    violet: "bg-violet-50 text-violet-600 ring-violet-100",
    rose: "bg-rose-50 text-rose-600 ring-rose-100",
};

const WebsiteStats = ({ dashboard }) => {
    return (
        <OverviewCard title="Website Activity" subtitle="Overall visitor interactions" accent="sky">
            <div className="grid grid-cols-2 gap-3">
                {stats(dashboard).map((item) => (
                    <div
                        key={item.title}
                        className={`flex items-center gap-3 rounded-xl ring-1 ${styles[item.accent]} p-3.5 transition-transform duration-200 hover:-translate-y-0.5`}
                    >
                        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/70">
                            {item.icon}
                        </div>
                        <div className="min-w-0">
                            <p className="text-lg font-bold tabular-nums text-slate-900">{item.value}</p>
                            <p className="truncate text-xs text-slate-500">{item.title}</p>
                        </div>
                    </div>
                ))}
            </div>
        </OverviewCard>
    );
};

export default WebsiteStats;